import comp from "./StandardsFilter";
export default comp;
